exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-terapias[data-v-1a2f5bfa]{display:flex;flex-direction:row;min-width:100%;min-height:100vh}.nav-terapias__drawer[data-v-1a2f5bfa]{display:flex;flex-direction:row;min-height:100%;max-width:fit-content}.nav-terapias__content[data-v-1a2f5bfa]{display:flex;flex-grow:1;background:#f8f8fc;width:95%}.nav-terapias__content>div[data-v-1a2f5bfa]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a2f5bfa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/Terapias/Terapias.scss
// module id = 1156
// module chunks = 0